<template>
  <DBox
    :id="'cmp-distribution-accounts-account_sidewindow-invoice-list'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      :id="'distribution-accounts-account_sidewindow-invoice_list'"
      class="h1 dbox1"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('invoice_no')">
            <span
              @click.stop="(e) => onRowClicked(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['invoice_ref']"
            >
              {{ item["invoice_ref"] }}
            </span>
          </td>
          <td v-bind="tdcon('recipient')">
            <span class="txtov" :title="item['name']">
              {{ item["name"] }}
            </span>
          </td>
          <td v-bind="tdcon('description')">
            <span class="txtov" :title="item['subject']">
              {{ item["subject"] }}
            </span>
          </td>
          <td v-bind="tdcon('amount')">
            <span class="txtov" :title="item['gross_amount_cc']">
              {{ $dft.curr(item["gross_amount_cc"]) }} &nbsp;
              <template>{{ item["currency_iso"] || "EUR" }}</template>
            </span>
          </td>

          <td v-bind="tdcon('status')">
            <span
              class="circle"
              :style="{
                backgroundColor: `${getInvoiceStatColor(item['color'])}`,
              }"
            ></span>
          </td>

          <td v-bind="tdcon('paypal_email')">
            <span
              class="dt-icon-container"
              @click.stop="(e) => emailLink(item)"
            >
              <img
                src="static/icons/email-blue.svg"
                class="dt-icon v5 s2"
                :alt="item['paypal_email']"
                :title="item['paypal_email']"
              />
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { sendMailHref } from "../../../../utility";
import { AccountService } from "../../services/account.service";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { getInvoiceStatColor } from "../../../accounting/models/color-status";

export default {
  components: {
    NTable,
    TextInput,
  },
  props: ["selectedAccountsDetails"],
  data: function () {
    return {
      selectedInvoice: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    list: function () {
      return this.selectedAccountsDetails.invoices || [];
    },
    headers: function () {
      return [
        createTableHeader("invoice_no"),
        // createTableHeader("sender"),
        // createTableHeader("date", { mw: 100 }),
        createTableHeader("recipient"),
        createTableHeader("description", { f: 1.5 }),
        createTableHeader("amount", { ta: "right", mw: 140 }),
        createTableHeader("status", { ta: "center", mw: 60 }),
        createTableHeader("paypal_email", {
          ta: "center",
          text: false,
          mw: 40,
        }),
      ];
    },
  },
  methods: {
    getInvoiceStatColor: getInvoiceStatColor,
    onAddClick: function () {
      this.$emit("add_click", "add_order_form");
    },
    onRowClicked(item) {
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },

    async emailLink(item) {
      const { invoice_id } = item;

      // await AccountService.displayPaypalPaymentMsgModal({ invoice_id });

      // let confirmationResult;

      // if (!item.paypal_email) {
      //   confirmationResult = await ConfirmationService.createP({
      //     body: `${this.$t("do_allow_recipient_pay_by_paypal")}\n${this.$t(
      //       "yes_will_include_paypal_payment"
      //     )}\n${this.$t("no_display_only_not_include_option")}\n${this.$t(
      //       "cancel_will_cancel_option"
      //     )}`,
      //     results: [
      //       createConfirmResult({
      //         value: "cancel",
      //         text: "Cancel",
      //         classes: ["s7"],
      //       }),
      //       createConfirmResult({
      //         value: "yes",
      //         text: "Yes",
      //         classes: ["v1 s7"],
      //       }),
      //       createConfirmResult({
      //         value: "no",
      //         text: "No, Display Only",
      //         classes: ["v1 s7"],
      //       }),
      //     ],
      //   });
      // }

      // if (confirmationResult == "no") {
      //   AccountService.includePaypalOption(invoice_id);
      // }

      //if (confirmationResult != "cancel") {
      const data = await AccountService.emailInvoiceDetails(invoice_id);
      console.log("::::::::::::", data);
      sendMailHref({
        mails: [data.data["email"]],
        body: data.data["invoice_email_text"],
        subject: "",
      });
      //}
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-account_sidewindow-invoice-list {
}
</style>
